document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.toggle-slider');
    if (!container) return;

    const slides = container.querySelectorAll('.toggle-slide');

    function updateToggleSlideClasses() {
        if (window.innerWidth <= 769) {
            // Force la class active en mobile
            slides.forEach(s => s.classList.add('toggle-slide-active'));
        } else {
            slides.forEach(s => s.classList.remove('toggle-slide-active'));
            if (slides.length) {
                slides[0].classList.add('toggle-slide-active');
            }
        }
    }

    // Au chargement
    updateToggleSlideClasses();

    // Au redimensionnement
    window.addEventListener('resize', updateToggleSlideClasses);

    slides.forEach(slide => {
        slide.addEventListener('click', () => {
            if (window.innerWidth > 769) {
                slides.forEach(s => s.classList.remove('toggle-slide-active'));
                slide.classList.add('toggle-slide-active');
            }
        });
    });
});
